import { CSSProperties, ReactNode } from 'react';

import { Footer } from 'modules/dashboard/components/Footer';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export interface ContainerFormProps {
  onCancel: () => void;
  onSubmit: () => void;
  disabled: boolean;
  titleSubmit: ReactNode;
  titleCancel?: ReactNode;
  disabledCancel?: boolean;
  children: ReactNode;
  buttonOrder?: 'submitFirst' | 'cancelFirst';
}

const ContainerForm = ({
  onCancel,
  onSubmit,
  disabled,
  titleSubmit,
  disabledCancel,
  titleCancel,
  children,
  buttonOrder = 'submitFirst',
}: ContainerFormProps) => {
  const FooterContainerStyle: CSSProperties = {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    borderTop: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
    background: COLOR_CONFIG.white,
    marginLeft: '-32px',
  };

  return (
    <>
      {children}
      <div style={FooterContainerStyle}>
        <Footer
          style={{ padding: '16px 32px' }}
          onCancel={onCancel}
          onSubmit={onSubmit}
          disabled={disabled}
          titleSubmit={titleSubmit}
          titleCancel={titleCancel}
          disabledCancel={disabledCancel}
          buttonOrder={buttonOrder}
        />
      </div>
    </>
  );
};

export default ContainerForm;
